/* Pulse announcement bar. Ported from AnnouncementBar.tsx: rotate the messages
   every 4.2s; under prefers-reduced-motion show the whole list joined instead
   of rotating. Vanilla, deferred, idempotent. */
(function () {
  if (window.__pulse_announcement) return;
  window.__pulse_announcement = true;

  var SEP = '  ·  ';

  function setup(root) {
    var msgs = Array.prototype.slice.call(root.querySelectorAll('.announce__msg'));
    var all = root.querySelector('.announce__all');
    if (!msgs.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced && msgs.length > 1 && all) {
      msgs.forEach(function (m) {
        m.hidden = true;
      });
      /* WP4-L (2026-09-06, corrected in fix round 1): JOIN EVERY MESSAGE, and let the CSS do
         the clipping. `.announce` is a fixed 3.4rem, so six joined messages did not grow the
         bar -- they wrapped out of it and over the nav. The fix for that is the
         `white-space: nowrap; overflow: hidden; text-overflow: ellipsis` rule on
         `.announce__all` in pulse-core.css.liquid, which is a purely VISUAL clip: the full
         string stays in the node, so a screen reader still reads all six.

         The first cut of this capped the join at two, which was wrong. The loop above sets
         `hidden` on every .announce__msg, and `hidden` removes an element from the
         ACCESSIBILITY TREE, not just from view -- so capping the join deleted four of the six
         messages for assistive tech while sighted users lost nothing they were not already
         losing to the ellipsis. Overflow is a layout problem and belongs entirely in CSS;
         never solve it by dropping content the AT copy depends on. */
      all.textContent = msgs
        .map(function (m) {
          return m.textContent.trim();
        })
        .join(SEP);
      all.hidden = false;
      return;
    }

    if (msgs.length < 2) return;

    /* CROSS-FADE, NOT A CUT (Andre, 2026-09-02: "make the copy in that top bar
       fade"). The outgoing message used to be hidden on the same tick the next
       one appeared, so only the arrival was ever animated and the departure was
       a hard cut. Now the current line fades out first, and the next fades in
       once it is gone. FADE_MS must stay in step with the .announce__msg
       transition in pulse-core.css.liquid. */
    var FADE_MS = 260;
    var index = 0;
    var swapping = false;

    var show = function (next, immediate) {
      if (swapping && !immediate) return;
      var out = msgs[index];
      var run = function () {
        out.hidden = true;
        out.classList.remove('is-out');
        index = next;
        var el = msgs[index];
        el.hidden = false;
        /* Start transparent, then let the class come off on the next frame so
           the transition has two values to move between. Setting hidden=false
           and removing the class in the same frame is a no-op: the browser has
           not painted the first state yet. */
        el.classList.add('is-out');
        void el.offsetWidth;
        el.classList.remove('is-out');
        swapping = false;
      };
      if (immediate) { run(); return; }
      swapping = true;
      out.classList.add('is-out');
      window.setTimeout(run, FADE_MS);
    };

    var timer = window.setInterval(function () {
      show((index + 1) % msgs.length);
    }, parseInt(root.getAttribute('data-interval'), 10) || 4200);

    /* WP4-L (2026-09-06): STOP THE TIMER WHEN THE SECTION GOES AWAY. The interval closed over
       msgs[], and nothing ever cleared it on unload, so a section removed in the theme editor
       left a live timer writing `hidden` to detached nodes every 4.2s for the rest of the
       session. Only unload is hooked: this file guards itself with window.__pulse_announcement
       and so does not re-run setup() on a section RELOAD, and clearing on load would therefore
       stop a rotation that nothing would start again. */
    var stop = function () { window.clearInterval(timer); };
    document.addEventListener('shopify:section:unload', function (event) {
      var t = event.target;
      if (t === root || (t && t.contains && t.contains(root))) stop();
    });

    /* Theme editor: selecting a message block should reveal it. */
    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      var i = msgs.indexOf(target);
      if (i > -1) {
        stop();
        show(i, true);   /* the editor wants the block NOW, not after a fade */
      }
    });
  }

  var boot = function () {
    document.querySelectorAll('[data-pulse-announce]').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
